import { render, staticRenderFns } from "./TransferenciasPage.vue?vue&type=template&id=71b0a642&"
import script from "./TransferenciasPage.vue?vue&type=script&lang=js&"
export * from "./TransferenciasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports